import { Const } from "../lib/const.cls";
import * as types from "@/types";
import * as RxFactory from "../../../../../store/api/rx-factory";
import * as Enpoints from "../../../../../store/api/endpoints";
import * as COMMON from "../../../../../store/commomFunction";


import moment from "moment";
import EventBus from "../lib/event-bus";
//isin list api 
export const EP_GET_ISIN_LIST = "https://webfeed.fxview.com/api/get/isins"
function goToUrl(url, action) {
    window.navigator.saysWho = (() => {
        const { userAgent } = navigator;
        let match = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(match[1])) {
            var temp = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
            return `IE ${temp[1] || ""}`;
        }
        match = match[2] ? [match[1], match[2]] : [navigator.appName, navigator.appVersion, "-?"];
        return match[0];
    })();
    // console.log("console firszt============>", url)
    if (navigator.saysWho.toLowerCase() === "safari") {
        location.replace(url);
    } else {
        // window.open(url, action)
        console.log("console firszt", url);
        var newWin = window.open(url, action);

        // alert("first")
        if (!newWin || newWin.closed || typeof newWin.closed == "undefined") {
            // alert("hi")
            location.replace(url);
        }
    }
}

export const actions = {
    //get isins list from api
    [Const.RUN_GET_ISINSLIST]({ commit, state, getters, dispatch }, req) {
        let expressRemote = EP_GET_ISIN_LIST
        RxFactory.get(expressRemote).map(response => response.data).subscribe(response => {
            if(response && response.data){
                commit(Const.SET_ISINS_LIST, response.data)
            }else{
                return;
            }
        })
    },
    //================================Choose Demo Live =============================
    [Const.RUN_CHOOSE_DEMO_LIVE]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_CHOOSE_DEMO_LIVE, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.financialDetails = result.res_data;
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    //Register send email otp
    [Const.RUN_SEND_EMAIL_OTP]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_SEND_EMAIL_OTP, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            const emailVerify = getters[types.GET_USER].is_email_verified;
            if (!error) {
                if(emailVerify == 0) {
                    credentials.localParams.parameter.$toasted.show("OTP is sent on your register email", {
                        position: "top-right",
                        duration: 3000,
                        type: 'success'
                    });
                  
                    // COMMON._messageDisplayFunction(credentials.localParams.parameter,'OTP is sent on your register email','success')
                    // COMMON._messageDisplayFunction(credentials.localParams.parameter, "suceessMsz16", "success");
                }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
            
        });
    },
    //Register Email verify
    [Const.RUN_REGISTER_EMAIL_VERIFY]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_REGISTER_EMAIL_VERIFY, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                let user_json = getters["GET_USER"];
                window.gtag("event", "OTP_verified", { event_name: "OTP_verified"});
                window.fbq("trackCustom", "OTP_verified", { value: "50", country: user_json.profile.residence_country, Currency: "USD" });

                if (credentials.localParams.parameter.$route.path == "/step3") {
                    credentials.localParams.parameter.$router.push('/step4')
                } else {
                    const emailVerify = getters[types.GET_USER].is_email_verified;
                    if(emailVerify == 0) {
                        credentials.localParams.parameter.$toasted.show("OTP verified successfully.", {
                            position: "top-right",
                            duration: 3000,
                            type: 'success'
                        });
                    }
                    window.location.reload();
                }
                credentials.localParams.parameter.msg = result.res_msg;
            } else {
                credentials.localParams.parameter.msg = result.res_msg;
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    //cancel withdrawal request
    [Const.RUN_CANCEL_WITHDRAWAL_REQUEST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_CANCEL_WITHDRAWAL_REQUEST, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.cancelwithData = {};
                credentials.localParams.parameter.$router.replace("/support/closeRequest");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_ADD_CRYPTO_Methods]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_ADD_CRYPTO_Methods, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.cryptoConvirsion();
                // credentials.localParams.parameter.ShowAddress = true
                // if(result.res_data.length > 0){
                // 	credentials.localParams.parameter.apiCryptoAddress = ''
                // }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_CRYPTO_Methods]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_CRYPTO_Methods, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.PaymentMethodList = result
                credentials.localParams.parameter.ShowAddress = true;
                if (result.res_data.length > 0) {
                    if (result.res_data[0].last_digit_card != '') {
                        credentials.localParams.parameter.selectcurrency = result.res_data[0].last_digit_card
                        credentials.localParams.parameter.apiCryptoAddress = result.res_data[0].online_payment_id;
                    } else {
                        credentials.localParams.parameter.apiCryptoAddress = ''
                    }
                    // credentials.localParams.parameter.selectcurrency = result.res_data[0].online_payment_id;
                }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_NOTIFICATION_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_NOTIFICATION_LIST, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (credentials.globalParams.read != undefined && !credentials.globalParams.read) {
                    commit(Const.SET_UNREAD_NOTIFICATION_DATA, result.res_data);
                } else {
                    commit(Const.SET_NOTIFICATION_LIST, result.res_data);
                    let inputJson = {
                        globalParams: {
                            read: 0,
                        },
                        localParams: { parameter: credentials.localParams.parameter },
                    };
                    dispatch(Const.RUN_GET_NOTIFICATION_LIST, inputJson);
                }
                //commit(Const.SET_NOTIFICATION_LIST, result.res_data)
            } else {
                //commit(Const.SET_NOTIFICATION_LIST, result.res_data)
                if (credentials.globalParams.read != undefined && !credentials.globalParams.read) {
                    commit(Const.SET_UNREAD_NOTIFICATION_DATA, []);
                } else {
                    commit(Const.SET_NOTIFICATION_LIST, []);
                }
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_BITCOIN_CONVERSION]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_BITCOIN_CONVERSION, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                // $(".mainContent").animate({ scrollTop: 0 }, "fast");
                if (credentials.localParams.from === 'create-account') {
                    credentials.localParams.parameter.convertedAmount = result.res_data.converted_amount;
                    if (result.res_data.converted_amount >= 5000) {
                        credentials.localParams.parameter.premiumECN = false;
                    }
                } else if (credentials.localParams.from === 'korapay') {
                    credentials.localParams.parameter.shwStep = credentials.globalParams.method_id;
                    credentials.localParams.parameter.korapayConvertedData = result.res_data;
                } else {
                    credentials.localParams.parameter.shwStep = 15;
                    credentials.localParams.parameter.bitcoinConversionData = result.res_data;
                }
            } else {
                credentials.localParams.parameter.korapayConvertedData = {};
                credentials.localParams.parameter.bitcoinConversionData = {};
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },

    [Const.RUN_GET_PRAXIS_URL]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_PRAXIS_URL, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                // credentials.localParams.parameter.showPraxisIframe = true
                // credentials.localParams.parameter.praxisUrl = result.res_data.redirect_url
                goToUrl(result.res_data.redirect_url, "_self");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },

    [Const.RUN_READ_UNREAD_NOTIFICATION]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_READ_UNREAD_NOTIFICATION, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                // commit(Const.SET_NOTIFICATION_LIST, [])
            } else {
                // commit(Const.SET_NOTIFICATION_LIST, [])
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },

    [Const.RUN_BANK_DEPOSIT_FOR_FEW_COUNTRIES]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_BANK_DEPOSIT_FOR_FEW_COUNTRIES, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                goToUrl(result.res_data.url, "_self");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_UNSUBSCRIBE_REQUEST_OTP]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_UNSUBSCRIBE_REQUEST_OTP, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.transaction_id = result.res_data.trans_id;
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_UNSUBSCRIBE_CHECK_OTP]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_UNSUBSCRIBE_CHECK_OTP, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (credentials.localParams.params) {
                    credentials.localParams.parameter.success = true;
                } else {
                    credentials.localParams.parameter.transaction_id = "";
                    credentials.localParams.parameter.congModuleWithdrawal = true;
                }
            } else {
                if (credentials.localParams.params) {
                    credentials.localParams.parameter.success = false;
                    credentials.localParams.parameter.msg = result.res_data;
                } else {
                    COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
                }
            }
        });
    },
    [Const.RUN_Unsubscribe_RESEND_EMAIL_LINK]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_Unsubscribe_RESEND_EMAIL_LINK, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, "suceessMsz16", "success");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },

    [Const.RUN_SUBSCRIPTION_REQUEST_OTP]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_SUBSCRIPTION_REQUEST_OTP, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.transaction_id = result.res_data.trans_id;
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_SUBSCRIPTION_CHECK_OTP]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_SUBSCRIPTION_CHECK_OTP, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (credentials.localParams.params) {
                    credentials.localParams.parameter.success = true;
                } else {
                    credentials.localParams.parameter.transaction_id = "";
                    credentials.localParams.parameter.congModuleWithdrawal = true;
                }
            } else {
                if (credentials.localParams.params) {
                    credentials.localParams.parameter.success = false;
                    credentials.localParams.parameter.msg = result.res_data;
                } else {
                    COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
                }
            }
        });
    },
    [Const.RUN_SUBSCRIPTION_RESEND_EMAIL_LINK]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_SUBSCRIPTION_RESEND_EMAIL_LINK, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, "suceessMsz16", "success");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },

    [Const.RUN_GET_SUBSCRIPTION_DETAIL]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_SUBSCRIPTION_DETAIL, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_SUBSCRIPTION_DETAIL, result.res_data);
            } else {
                commit(Const.SET_SUBSCRIPTION_DETAIL, {});
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },

    [Const.RUN_GET_LOYALITY_CARD_DETAIL]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_LOYALITY_CARD_DETAIL, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_LOYALITY_LAST_CREDIT, result.res_data.transactions);
                commit(Const.SET_LOYALITY_CARD_DETAIL, result.res_data.card);
                commit(Const.SET_LOYALITY_CARD_TXN, result.res_data.transactions);
            } else {
                commit(Const.SET_LOYALITY_CARD_DETAIL, []);
                commit(Const.SET_LOYALITY_CARD_TXN, {});
                commit(Const.SET_LOYALITY_LAST_CREDIT, {});
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_LOYALITY_TXN_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_LOYALITY_TXN_LIST, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_LOYALITY_CARD_TXN, result.res_data);
            } else {
                commit(Const.SET_LOYALITY_CARD_TXN, {});
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_LOYALITY_REQUEST_OTP]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_LOYALITY_REQUEST_OTP, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.transaction_id = result.res_data.trans_id;
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_msg, "error");
            }
        });
    },
    [Const.RUN_LOYALITY_REDEEM_CHECK_OTP]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_LOYALITY_REDEEM_CHECK_OTP, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (credentials.localParams.params) {
                    credentials.localParams.parameter.success = true;
                } else {
                    credentials.localParams.parameter.transaction_id = "";
                    credentials.localParams.parameter.congModuleIntTransfer = true;
                    credentials.localParams.parameter.reset();
                    //credentials.localParams.parameter.$parent.cardDetailFunc()
                }
            } else {
                if (credentials.localParams.params) {
                    credentials.localParams.parameter.success = false;
                    credentials.localParams.parameter.msg = result.res_data;
                } else {
                    COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
                    credentials.localParams.parameter.reset();
                }
            }
        });
    },
    [Const.RUN_LOYALITY_TRANSFER_CHECK_OTP]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_LOYALITY_TRANSFER_CHECK_OTP, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (credentials.localParams.params) {
                    credentials.localParams.parameter.success = true;
                } else {
                    credentials.localParams.parameter.transaction_id = "";
                    credentials.localParams.parameter.congModuleIntTransfer = true;
                    credentials.localParams.parameter.res_data = result.res_data;
                }
            } else {
                if (credentials.localParams.params) {
                    credentials.localParams.parameter.success = false;
                    credentials.localParams.parameter.msg = result.res_data;
                } else {
                    COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
                }
            }
        });
    },
    [Const.RUN_LOYALITY_EMAIL_VERIFY_LINK]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_LOYALITY_EMAIL_VERIFY_LINK, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, "suceessMsz16", "success");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    //=========================wallet==================================
    [Const.RUN_CREATE_WALLET_ACCOUNT]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_CREATE_WALLET_ACCOUNT, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.reset();
                COMMON._messageDisplayFunction(credentials.localParams.parameter, "wallet create successfully", "success");
                dispatch(Const.RUN_GET_WALLET_DETAIL, { globalParams: {}, localParams: { parameter: credentials.localParams.parameter } });
            } else {
                credentials.localParams.parameter.reset();
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_WALLET_BALANCE]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_WALLET_BALANCE, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_WALLET_BALANCE, result.res_data);
            } else {
                commit(Const.SET_WALLET_BALANCE, {});
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_WALLET_DETAIL]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_WALLET_DETAIL, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                let count = 0,
                    currencyArray = [],
                    wallet_list = [],
                    allAcc = {};
                if (Object.keys(result.res_data.wallet).length > 0) {
                    for (var key in result.res_data.wallet) {
                        count++;
                        currencyArray.push(result.res_data.wallet[key].wallet.currency);

                        let data = result.res_data.wallet[key].wallet;
                        data["margin_detail"] = result.res_data.wallet[key].margin_detail;
                        wallet_list.push(data);

                        if (count == Object.keys(result.res_data.wallet).length) {
                            commit(Const.SET_WALLET_CURRENCY_DATA, currencyArray);

                            let livelist = getters[Const.GET_LIVE_ACCOUNT_LIST];
                            allAcc["records"] = wallet_list.concat(livelist.records || []);
                            allAcc["totalRecords"] = wallet_list.length + (livelist.totalRecords || 0);
                            commit(Const.SET_ALL_ACCOUNT_LIST, allAcc);
                        }
                    }
                } else {
                    commit(Const.SET_WALLET_CURRENCY_DATA, []);

                    let livelist = getters[Const.GET_LIVE_ACCOUNT_LIST];
                    allAcc["records"] = wallet_list.concat(livelist.records || []);
                    allAcc["totalRecords"] = wallet_list.length + (livelist.totalRecords || 0);
                    commit(Const.SET_ALL_ACCOUNT_LIST, allAcc);
                }
                commit(Const.SET_WALLET_ACCOUNT, result.res_data.wallet);
                commit(Const.SET_WALLET_TRANSACTION, result.res_data.transactions);
            } else {
                commit(Const.SET_WALLET_ACCOUNT, {});
                commit(Const.SET_WALLET_TRANSACTION, {});
                commit(Const.SET_WALLET_CURRENCY_DATA, []);

                let livelist = getters[Const.GET_LIVE_ACCOUNT_LIST];
                let allAcc = {};
                allAcc["records"] = livelist.records || [];
                allAcc["totalRecords"] = livelist.totalRecords || 0;
                commit(Const.SET_ALL_ACCOUNT_LIST, allAcc);

                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_WALLET_TRANSACTION]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_WALLET_TRANSACTION, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_WALLET_TRANSACTION, result.res_data);
            } else {
                commit(Const.SET_WALLET_TRANSACTION, {});
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    //==============================
    [Const.RUN_LANGUAGE_API]({ commit, state, getters }, credentials) {
        localStorage.setItem("lang", credentials.globalParams.lang);
        if (credentials.localParams.page == "left-bar") {
            //document.cookie = credentials.globalParams.lang;
            COMMON._executeApi(Enpoints.EP_LANGUAGE_API, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
                if (!error) {
                } else {
                }
            });
        } else {
        }
    },
    [Const.RUN_CONVERT_WALLET_BALANCE]({ commit, state, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_CONVERT_WALLET_BALANCE, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                //console.log(result.res_data)
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_AUTOCHARTIST_URL]({ commit, state, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_AUTOCHARTIST_URL, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                let url = credentials.localParams.parameter.$env_var.autoChartistUrlDownload;
                goToUrl(url, "_blank");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    //====================research & education==============================================================
    [Const.RUN_GET_WEBINAR_DATA]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_WEBINAR_DATA, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.web_data = result.res_data;
            } else {
                credentials.localParams.parameter.web_data = [];
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_TUT_COURSE_CATEGORY]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_TUT_COURSE_CATEGORY, credentials, "", commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.course_cat = result.res_data;
                if (Object.keys(result.res_data).length > 0 && result.res_data.course.length > 0 && Object.keys(result.res_data.category).length > 0) {
                    credentials.localParams.parameter.courseId = result.res_data.course[0]._id;
                    if (result.res_data.category[result.res_data.course[0]._id].length > 0) {
                        credentials.localParams.parameter.categoryId = result.res_data.category[result.res_data.course[0]._id][0]._id;
                        let input_json = {
                            globalParams: {
                                course_id: result.res_data.course[0]._id,
                                cat_id: result.res_data.category[result.res_data.course[0]._id][0]._id,
                            },
                            localParams: { parameter: credentials.localParams.parameter },
                        };
                        dispatch(Const.RUN_GET_VIDEO_TUTORIAL, input_json);
                    }
                } else {
                    credentials.localParams.parameter.course_cat = {};
                }
            } else {
                credentials.localParams.parameter.course_cat = {};
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_VIDEO_TUTORIAL]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_VIDEO_TUTORIAL, credentials, "", commit, (error, result) => {
            if (!error) {
                commit(Const.SET_VIDEO_TUTORIAL, result.res_data);
            } else {
                commit(Const.SET_VIDEO_TUTORIAL, []);
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_POST_DATA]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_POST_DATA, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.post_data = result.res_data;
            } else {
                credentials.localParams.parameter.post_data = [];
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    //====================trading-tools===================================================================
    [Const.RUN_GET_AUTO_CHARTIST_WEB_URL]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_AUTO_CHARTIST_WEB_URL, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.url = result.res_data.url;
            } else {
                credentials.localParams.parameter.url = "";
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_ECONOMIC_CALENDER_DATA]({ commit, state, getters, dispatch }, credentials) {
        let auto_chartist = "";
        if (credentials.globalParams.from == "") {
            auto_chartist = getters[Const.GET_ECONOMIC_CALENDER_DATA];
        } else {
            auto_chartist = {};
        }
        COMMON._executeApi(Enpoints.EP_GET_ECONOMIC_CALENDER_DATA, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (auto_chartist != "" && auto_chartist != undefined) {
                    if (result.res_data.length > 0) {
                        credentials.localParams.parameter.responseData = result.res_data;
                        for (let i = 0; i <= result.res_data.length - 1; i++) {
                            const eventDate = moment(result.res_data[i].date).format("YYYY-MM-DD");
                            if (credentials.localParams.parameter.upnextDate) {
                                if (Date.parse(result.res_data[i].date) < Date.now().toString()) {
                                    continue;
                                }
                            }
                            if (auto_chartist[eventDate]) {
                                auto_chartist[eventDate].push(result.res_data[i]);
                            } else {
                                auto_chartist[eventDate] = [];
                                auto_chartist[eventDate].push(result.res_data[i]);
                            }

                            if (i == result.res_data.length - 1) {
                                commit(Const.SET_ECONOMIC_CALENDER_DATA, auto_chartist);
                                if (credentials.localParams.parameter.upnextDate) {
                                    credentials.localParams.parameter.upnextDate = false;
                                }

                                if (credentials.localParams.parameter.countries.length > 0) {
                                    credentials.localParams.parameter.Countrywiselisting(credentials.localParams.parameter.countries);
                                }

                                // if(credentials.localParams.parameter.priority == '2' || credentials.localParams.parameter.priority == '3'){
                                // 	if(credentials.localParams.parameter.countries.length > 0){
                                // 		credentials.localParams.parameter.Countrywiselisting(credentials.localParams.parameter.countries)
                                // 	}else{
                                // 		credentials.localParams.parameter.selectcountrymessage = 'Please select the Country'
                                // 	}
                                // }
                            }
                        }
                    }
                } else {
                    commit(Const.SET_ECONOMIC_CALENDER_DATA, result.res_data);
                }
            } else {
                commit(Const.SET_ECONOMIC_CALENDER_DATA, []);
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_CALENDER_EVENT]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_CALENDER_EVENT, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.eventData = result.res_data;
            } else {
                credentials.localParams.parameter.eventData = [];
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_REFER_Friend]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_REFER_Friend, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.congoDiv = true;
                credentials.localParams.parameter.list();
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_REFER_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_REFER_LIST, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_REFER_LIST, result.res_data);
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_REFER_DELETE]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_REFER_DELETE, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                // COMMON._messageDisplayFunction(credentials.localParams.parameter,result.data.msg,'success')
                credentials.localParams.parameter.congoDelEmail = true;
                credentials.localParams.parameter.list();
            } else {
                credentials.localParams.parameter.emailData = {};
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_COUPON_PLAN]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_COUPON_PLAN, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (result.res_data != "") {
                    let amount = credentials.localParams.parameter.amount - result.res_data[0].discount_amount;
                    credentials.localParams.parameter.coupon_apply = true;
                    credentials.localParams.parameter.coupon_code1 = result.res_data[0].code;
                    credentials.localParams.parameter.coupon_price = result.res_data[0].discount_amount;
                    if (amount < 0) {
                        credentials.localParams.parameter.amount = 0;
                    } else {
                        credentials.localParams.parameter.amount = amount;
                    }
                } else {
                    credentials.localParams.parameter.amount = credentials.localParams.parameter.planDetailData.amount;
                }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_COUPON_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_COUPON_LIST, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_COUPON_LIST, result.res_data);
            } else {
                commit(Const.SET_COUPON_LIST, []);
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_CHECK_COUPON_VALIDITY]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_CHECK_COUPON_VALIDITY, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.applycoupon(result.res_data, "apply");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },

    [Const.RUN_GET_AUTOCHARTIST_DATA]({ commit, state, getters, dispatch }, credentials) {
        let auto_chartist = [];
        let auto_chartistJson = getters[Const.GET_AUTO_CHARTIST];
        COMMON._executeApi(Enpoints.EP_GET_AUTOCHARTIST_DATA, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (auto_chartist != "" && auto_chartist != undefined) {
                    auto_chartist = auto_chartistJson.records;
                    let signalJson = {};
                    if (result.res_data.length > 0) {
                        for (let i = 0; i <= result.res_data.length - 1; i++) {
                            auto_chartist.push(result.res_data[i]);
                            if (i == result.res_data.length - 1) {
                                signalJson["totalRecords"] = result.res_data.length + auto_chartist.length;
                                signalJson["records"] = auto_chartist;
                                commit(Const.SET_AUTO_CHARTIST, signalJson);
                            }
                        }
                    } else {
                        signalJson["totalRecords"] = auto_chartist.length;
                        signalJson["records"] = auto_chartist;
                        commit(Const.SET_AUTO_CHARTIST, signalJson);
                    }
                } else {
                    let signalArray = [],
                        signalJson = {};
                    if (result.res_data.length > 0) {
                        for (let i = 0; i <= result.res_data.length - 1; i++) {
                            signalArray.push(result.res_data[i]);

                            if (i == result.res_data.length - 1) {
                                signalJson["totalRecords"] = result.res_data.length;
                                signalJson["records"] = signalArray;
                                commit(Const.SET_AUTO_CHARTIST, signalJson);
                            }
                        }
                    } else {
                        signalJson["totalRecords"] = 0;
                        signalJson["records"] = signalArray;
                        commit(Const.SET_AUTO_CHARTIST, signalJson);
                    }
                }
            } else {
                commit(Const.SET_AUTO_CHARTIST, []);
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_HOOPS_DATA]({ commit, state, getters, dispatch }, credentials) {
        let hoops_data = [];
        let hoops_dataJson = getters[Const.GET_HOOPS_DATA];
        COMMON._executeApi(Enpoints.EP_GET_HOOPS_DATA, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (parseInt(credentials.localParams.parameter.page) > 1) {
                    if (hoops_dataJson.totalRecords) {
                        hoops_dataJson["totalRecords"] = result.res_data.length + hoops_dataJson["totalRecords"];
                        hoops_dataJson["records"] = hoops_dataJson["records"].concat(result.res_data);
                    } else {
                        hoops_dataJson["totalRecords"] = result.res_data.length;
                        hoops_dataJson["records"] = result.res_data;
                    }
                    commit(Const.SET_HOOPS_DATA, hoops_dataJson);
                } else {
                    let hoops_data = {};
                    hoops_data["totalRecords"] = result.res_data.length;
                    hoops_data["records"] = result.res_data;
                    commit(Const.SET_HOOPS_DATA, hoops_data);
                }
                /*if(hoops_data != '' && hoops_data != undefined){
                    hoops_data = hoops_dataJson.records
                    let signalJson={} ;
                    if(result.res_data.length > 0){
                        for(let i=0 ; i<=result.res_data.length-1 ; i++){
                            hoops_data.push(result.res_data[i])
                            if(i == result.res_data.length-1){
                                signalJson['totalRecords'] = result.res_data.length + hoops_data.length
                                signalJson['records'] = hoops_data
                                commit(Const.SET_HOOPS_DATA, signalJson)
                            }
                        }
                    }else{
                        signalJson['totalRecords'] = hoops_data.length
                        signalJson['records'] = hoops_data
                        commit(Const.SET_HOOPS_DATA, signalJson)
                    }
                }else{
                    let signalArray = [] ,signalJson={} ;
                    if(result.res_data.length > 0){
                        for(let i=0 ; i<=result.res_data.length-1 ; i++){
                            signalArray.push(result.res_data[i])
                        	
                            if(i == result.res_data.length-1){
                                signalJson['totalRecords'] = result.res_data.length
                                signalJson['records'] = signalArray
                                commit(Const.SET_HOOPS_DATA, signalJson)
                            }
                        }
                    }else{
                        signalJson['totalRecords'] = 0
                        signalJson['records'] = signalArray
                        commit(Const.SET_HOOPS_DATA, signalJson)
                    }
                }*/
            } else {
                commit(Const.SET_HOOPS_DATA, []);
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_CURRENT_NEWS]({ commit, state, getters, dispatch }, credentials) {
        let newsJson = getters[Const.GET_CURRENT_NEWS];
        COMMON._executeApi(Enpoints.EP_GET_CURRENT_NEWS, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                result.res_data = result.res_data.filter((val) => val.tags || val.title || val.description);
                if (credentials.localParams.page && credentials.localParams.page == "news") {
                    if (credentials.localParams.parameter.localNewsData.length == 0) {
                        credentials.localParams.parameter.localNewsData = result.res_data.slice(0, 10);
                    }
                }
                if (parseInt(credentials.localParams.parameter.page) > 1) {
                    if (newsJson.totalRecords) {
                        newsJson["totalRecords"] = newsJson["totalRecords"] + result.res_data.length;
                        newsJson["records"] = newsJson["records"].concat(result.res_data);
                    } else {
                        newsJson["totalRecords"] = result.res_data.length;
                        newsJson["records"] = result.res_data;
                    }
                    commit(Const.SET_CURRENT_NEWS, newsJson);
                } else {
                    let news = {};
                    news["totalRecords"] = result.res_data.length;
                    news["records"] = result.res_data;
                    commit(Const.SET_CURRENT_NEWS, news);
                }
                /*	let auto_array = [];
                    if(auto_array != '' && auto_array != undefined){
                    auto_array = newsJson.records
                    let newsJson={} ;
                    if(result.res_data.length > 0){
                        for(let i=0 ; i<=result.res_data.length-1 ; i++){
                            auto_array.push(result.res_data[i])
                        	
                            if(i == result.res_data.length-1){
                                newsJson['totalRecords'] = result.res_data.length + auto_array.length
                                newsJson['records'] = auto_array
                                commit(Const.SET_CURRENT_NEWS, newsJson)
                            }
                        }
                    }else{
                        newsJson['totalRecords'] = auto_array.length
                        newsJson['records'] = auto_array
                        commit(Const.SET_CURRENT_NEWS, newsJson)
                    }
                }else{
                    let newsArray = [] ,newsJson={} ;
                    if(result.res_data.length > 0){
                        for(let i=0 ; i<=result.res_data.length-1 ; i++){
                            newsArray.push(result.res_data[i])
                        	
                            if(i == result.res_data.length-1){
                                newsJson['totalRecords'] = result.res_data.length
                                newsJson['records'] = newsArray
                                commit(Const.SET_CURRENT_NEWS, newsJson)
                            }
                        }
                    }else{
                        newsJson['totalRecords'] = 0
                        newsJson['records'] = newsArray
                        commit(Const.SET_CURRENT_NEWS, newsJson)
                    }
                }*/
            } else {
                commit(Const.SET_CURRENT_NEWS, {});
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_CURRENT_NEWS_DETAIL]({ commit, state, getters, dispatch }, credentials) {
        let newsJson = getters[Const.GET_CURRENT_NEWS_DETAIL];
        COMMON._executeApi(Enpoints.EP_GET_CURRENT_NEWS_DETAIL, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                newsJson[credentials.globalParams.id] = result.res_data;
                commit(Const.SET_CURRENT_NEWS_DETAIL, newsJson);
                credentials.localParams.parameter.id = "";
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_SIGNAL_CENTRE_DATA]({ commit, state, getters, dispatch }, credentials) {
        let auto_chartist = [];
        let auto_chartistJson = getters[Const.GET_SIGNAL_CENTRE];
        COMMON._executeApi(Enpoints.EP_GET_SIGNAL_CENTRE_DATA, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (auto_chartist != "" && auto_chartist != undefined) {
                    let signalJson = {};
                    if (result.res_data.length > 0) {
                        for (let i = 0; i <= result.res_data.length - 1; i++) {
                            auto_chartist.push(result.res_data[i]);

                            if (i == result.res_data.length - 1) {
                                signalJson["totalRecords"] = result.res_data.length + auto_chartist.length;
                                signalJson["records"] = auto_chartist;
                                commit(Const.SET_SIGNAL_CENTRE, signalJson);
                            }
                        }
                    } else {
                        signalJson["totalRecords"] = auto_chartist.length;
                        signalJson["records"] = auto_chartist;
                        commit(Const.SET_SIGNAL_CENTRE, signalJson);
                    }
                } else {
                    let signalArray = [],
                        signalJson = {};
                    if (result.res_data.length > 0) {
                        for (let i = 0; i <= result.res_data.length - 1; i++) {
                            signalArray.push(result.res_data[i]);

                            if (i == result.res_data.length - 1) {
                                signalJson["totalRecords"] = result.res_data.length;
                                signalJson["records"] = signalArray;
                                commit(Const.SET_SIGNAL_CENTRE, signalJson);
                            }
                        }
                    } else {
                        signalJson["totalRecords"] = 0;
                        signalJson["records"] = signalArray;
                        commit(Const.SET_SIGNAL_CENTRE, signalJson);
                    }
                }
            } else {
                commit(Const.SET_SIGNAL_CENTRE, []);
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_SUB_PLAN_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_SUB_PLAN_LIST, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_SUB_PLAN_LIST, result.res_data);
            } else {
                commit(Const.SET_SUB_PLAN_LIST, []);
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_SUB_PLAN_DETAIL]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_SUB_PLAN_DETAIL, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_SUB_PLAN_DETAIL, result.res_data);
                if (credentials.localParams.page == "create_plan_ticket") {
                    for (let i = 0; i <= result.res_data[0].details.length - 1; i++) {
                        if (result.res_data[0].details[i].id == credentials.localParams.plan_detail_id) {
                            credentials.localParams.parameter.planDetailData = result.res_data[0].details[i];
                        }
                        if (i == result.res_data[0].details.length - 1) {
                            credentials.localParams.parameter.userDepositFunc();
                        }
                    }
                }
            } else {
                commit(Const.SET_SUB_PLAN_DETAIL, []);
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_SUB_OPERATION_LINK]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_SUB_OPERATION_LINK, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, "suceessMsz10", "success");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_SUB_OPERATION]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_SUB_OPERATION, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.transaction_id = result.res_data.trans_id;
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_CREATE_SUB_TICKET]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_CREATE_SUB_TICKET, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                let get_user = getters[types.GET_USER];
                let sdata = result.res_data.data[0];
                let sub_json = { pdetail_id: sdata.pdetail_id, plan_id: sdata.id, plan_name: sdata.plan_name, plan_type: sdata.plan_type };
                get_user.profile.subscriptions.push(sub_json);
                commit(types.SET_STATE, get_user);
                var user = localStorage.getItem("user");
                user = atob(user);
                user = JSON.parse(user);
                user.profile.subscriptions.push(sub_json);
                localStorage.setItem("user", btoa(JSON.stringify(user)));

                if (credentials.localParams.params) {
                    credentials.localParams.parameter.success = true;
                } else {
                    credentials.localParams.parameter.transaction_id = "";
                    credentials.localParams.parameter.congModuleIntTransfer = true;
                }
            } else {
                if (credentials.localParams.params) {
                    credentials.localParams.parameter.success = false;
                    credentials.localParams.parameter.msg = result.res_data;
                } else {
                    COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
                }
            }
        });
    },
    [Const.RUN_UNSUB_SERVICE]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_UNSUB_SERVICE, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, "suceessMsz11", "success");
                let get_user = getters[types.GET_USER];
                let subArray = get_user.profile.subscriptions;

                for (let i = 0; i <= subArray.length - 1; i++) {
                    if (parseInt(subArray[i].id) == parseInt(credentials.globalParams.subscription_id)) {
                        subArray.splice(i, 1);
                    }

                    if (i == subArray.length - 1) {
                        get_user.profile.subscriptions = subArray;
                        commit(types.SET_STATE, get_user);
                        var user = localStorage.getItem("user");
                        user = atob(user);
                        user = JSON.parse(user);
                        user.profile.subscriptions = subArray;
                        localStorage.setItem("user", btoa(JSON.stringify(user)));
                    }
                }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },

    [Const.RUN_GET_VPS_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_VPS_LIST, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_VPS_LIST, result.res_data);
            } else {
                commit(Const.SET_VPS_LIST, {});
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_VPS_DETAIL]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_VPS_DETAIL, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_VPS_DETAIL, result.res_data);
            } else {
                commit(Const.SET_VPS_DETAIL, []);
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_VPS_RESTART]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_VPS_RESTART, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.listing();
                COMMON._messageDisplayFunction(credentials.localParams.parameter, "suceessMsz12", "success");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_VPS_REBOOT]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_VPS_REBOOT, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.listing();
                COMMON._messageDisplayFunction(credentials.localParams.parameter, "suceessMsz13", "success");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_VPS_SHUTDOWN]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_VPS_SHUTDOWN, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.listing();
                COMMON._messageDisplayFunction(credentials.localParams.parameter, "suceessMsz14", "success");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_VPS_CHANGE_PASSWORD]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_VPS_CHANGE_PASSWORD, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.listing();
                credentials.localParams.parameter.reset();
                COMMON._messageDisplayFunction(credentials.localParams.parameter, "suceessMsz15", "success");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    //=================================user==============================================================
    [Const.RUN_GET_USER_PROFILE]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_USER_PROFILE, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_USER_PROFILE, result.res_data[0]);
            }
        });
    },
    [Const.RUN_GET_USER_REGISTERATION_STEP_DATA]({ commit, state, dispatch, getters }, credentials) {
        let user_info = getters[types.GET_USER];
        const _that = credentials.localParams.parameter;
        /*if (parseInt(user_info.step) >= 2) {
            _that.disable = true
        }*/
        // console.log(parseInt(credentials.localParams.step), user_info.step, ">")
        if (parseInt(credentials.localParams.step) <= parseInt(user_info.step) || parseInt(credentials.localParams.step) == parseInt(user_info.step) + 1) {
        } else {
            let stepData = parseInt(user_info.step) == 0 ? "/step1" : "/step" + (parseInt(user_info.step) + 1);
            _that.$router.replace(stepData);
        }
        COMMON._executeApi(Enpoints.EP_GET_USER_REGISTERATION_STEP_DATA, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                switch (parseInt(credentials.localParams.step)) {
                    case 1:
                        let dob = moment(result.res_data[0].profile.dob).format("YYYY-MM-DD");
                        _that.default_country = result.res_data[0].profile.residence_country;
                        // _that.readonly = true
                        dob = new Date(dob);
                        if (parseInt(user_info.account_type) == 0) {
                            _that.ind_f_name = result.res_data[0].profile.firstname;
                            _that.ind_l_name = result.res_data[0].profile.lastname;
                            _that.ind_dob = moment(new Date(dob)).format("YYYY-MM-DD");

                            //adress-detail
                            _that.ind_city = result.res_data[0].profile.city;
                            _that.ind_post_code = result.res_data[0].profile.post_code;
                            _that.address1 = result.res_data[0].profile.address1;
                            _that.address2 = result.res_data[0].profile.address2;
                            _that.ind_residence_country = result.res_data[0].profile.residence_country;

                            //session

                            _that.mobile_number = result.res_data[0].mobile_no;
                            _that.mobile_no = result.res_data[0].mobile_no;
                            if (_that.mobile_number) {
                                _that.isDisabled = true;
                            }
                            _that.select_currency = result.res_data[0].currency;
                            //other detail
                            _that.ind_pep = parseInt(result.res_data[0].profile.pep);
                            _that.us_person = parseInt(result.res_data[0].profile.us_person);
                            _that.usFatca = result.res_data[0].profile.usFatca;
                            _that.is_crs = result.res_data[0].profile.is_crs;
                            _that.crs = result.res_data[0].profile.CRSNUMBER;
                            
                            if (_that.$env_var.jurisdiction_tax_residence[1] == result.res_data[0].profile.CRSREASON) {
                                _that.jurisdiction_tax_residence = 1;
                            } else if (_that.$env_var.jurisdiction_tax_residence[3] == result.res_data[0].profile.CRSREASON) {
                                _that.jurisdiction_tax_residence = 3;
                            } else if (result.res_data[0].profile.CRSREASON) {
                                _that.jurisdiction_tax_residence = 2;
                                _that.crs_reason = result.res_data[0].profile.CRSREASON;
                            }
                        } else if (parseInt(user_info.account_type) == 1) {
                            let member_dob = moment(result.res_data[0].profile.member_dob).format("YYYY-MM-DD");
                            member_dob = new Date(member_dob);
                            _that.joint_f_name_member1 = result.res_data[0].profile.firstname;
                            _that.joint_l_name_member1 = result.res_data[0].profile.lastname;
                            _that.joint_dob_member1 = moment(new Date(dob)).format("YYYY-MM-DD");
                            _that.joint_f_name_member2 = result.res_data[0].profile.member_fname;
                            _that.joint_l_name_member2 = result.res_data[0].profile.member_lname;
                            _that.joint_dob_member2 = moment(new Date(member_dob)).format("YYYY-MM-DD");

                            _that.select_currency = result.res_data[0].currency;
                            _that.mobile_number = result.res_data[0].mobile_no;

                            _that.address1 = result.res_data[0].profile.address1;
                            _that.address2 = result.res_data[0].profile.address2;

                            _that.ind_city = result.res_data[0].profile.city;
                            _that.ind_post_code = result.res_data[0].profile.post_code;
                            _that.ind_residence_country = result.res_data[0].profile.residence_country;

                            _that.us_person = parseInt(result.res_data[0].profile.us_person);
                        } else if (parseInt(user_info.account_type) == 2) {
                            _that.cor_f_name = result.res_data[0].profile.firstname;
                            _that.cor_l_name = result.res_data[0].profile.lastname;
                            _that.cor_incor_date = moment(new Date(result.res_data[0].profile.incorporation_date)).format("YYYY-MM-DD");
                            _that.cor_company_name = result.res_data[0].profile.company_name;
                            _that.cor_dob = moment(new Date(dob)).format("YYYY-MM-DD");

                            _that.select_currency = result.res_data[0].currency;
                            _that.mobile_number = result.res_data[0].mobile_no;

                            _that.address1 = result.res_data[0].profile.address1;
                            _that.address2 = result.res_data[0].profile.address2;

                            _that.ind_city = result.res_data[0].profile.city;
                            _that.ind_post_code = result.res_data[0].profile.post_code;
                            _that.ind_residence_country = result.res_data[0].profile.residence_country;

                            _that.us_person = parseInt(result.res_data[0].profile.us_person);
                        }
                        //_that.datePickerFunc()

                        _that.countryFunc();
                        break;
                    case 2:
                        _that.occupation = parseInt(result.res_data[0].profile.occupation) || "";
                        _that.education = parseInt(result.res_data[0].profile.education) || "";
                        _that.yearly_income = result.res_data[0].profile.yearly_income || "";
                        _that.net_worth = result.res_data[0].profile.net_worth || "";
                        _that.source_of_fund = result.res_data[0].profile.source_of_fund || "";

                        let i, ques_ans_list1 = [];
                        result.res_data[0].answers.forEach((v, i) => {
                            _that.ques_ans_array[v.ques_id] = v.ans_id;
                            if(v.ques_id == 48){
                                _that.education_qual = v.ans_id
                            } else if (v.ques_id == 47) {
                                _that.question_answer = v.ans_id
                            }
                        });
                        if (parseInt(result.res_data[0].profile.terms_agreed) == 1) {
                            _that.check1 = true;
                            _that.check2 = true;
                            _that.check3 = true;
                            _that.check4 = true;
                        }
                        break;
                    case 3:
                        if (result.res_data[0].documents.length > 0) {
                            if (credentials.localParams.deleteOnLoad) {
                                for (let i = 0; i <= result.res_data[0].documents.length - 1; i++) {
                                    if (result.res_data[0].documents[i].document_type != "Proof of Residence") {
                                        if (_that.documentJsonData[result.res_data[0].documents[i].document_type.split(" ").join("_")] == undefined) {
                                            _that.documentJsonData[result.res_data[0].documents[i].document_type.split(" ").join("_")] = [];
                                        }
                                        result.res_data[0].documents[i].name = result.res_data[0].documents[i].document;
                                        _that.documentJsonData[result.res_data[0].documents[i].document_type.split(" ").join("_")].push(result.res_data[0].documents[i]);
                                    } else {
                                        let input_json = {
                                            globalParams: {
                                                id: result.res_data[0].documents[i].id,
                                            },
                                            localParams: { parameter: this, getData: null },
                                        };
                                        dispatch(types.RUN_DELETE_DOC, input_json);
                                    }
                                }
                            } else {
                                for (let i = 0; i <= result.res_data[0].documents.length - 1; i++) {
                                    if (_that.documentJsonData[result.res_data[0].documents[i].document_type.split(" ").join("_")] == undefined) {
                                        _that.documentJsonData[result.res_data[0].documents[i].document_type.split(" ").join("_")] = [];
                                    }
                                    result.res_data[0].documents[i].name = result.res_data[0].documents[i].document;
                                    _that.documentJsonData[result.res_data[0].documents[i].document_type.split(" ").join("_")].push(result.res_data[0].documents[i]);
                                }
                            }
                        } else {
                            // _that.documentJsonSitutaion = { 'identity_document': 'upload', 'residence_document': 'upload', 'ipv_document': 'upload' }
                        }

                        _that.idnumber = result.res_data[0].profile.P_IDNUMBER;

                        if (parseInt(result.res_data[0].profile.APPROVED_TO_PROCEED) == 1) {
                            _that.acceptCountryFlag = 1;
                        } else {
                            _that.acceptCountryFlag = 2;
                        }
                        break;
                }
            }
        });
    },
    [Const.RUN_USER_NOTIFICATIONS]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_USER_NOTIFICATIONS, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_USER_NOTIFICATIONS, result.res_data);
            } else {
                commit(Const.SET_USER_NOTIFICATIONS, []);
            }
        });
    },
    [Const.RUN_GET_COUNTRIES_LIST]({ commit, state, dispatch, getters }, credentials) {
        let countryResponse = getters[types.GET_COUNTRIES_FOR_CLIENT];
        let country_array = [],
            count = 0;
        for (var key in countryResponse) {
            count++;
            country_array.push(countryResponse[key]);
            if (count == Object.keys(countryResponse).length) {
                commit(Const.SET_COUNTRIES_LIST, country_array);
                // console.log('country_array===',country_array)
                if (credentials.localParams.page) {
                    credentials.localParams.parameter.residence_country = country_array;
                    // credentials.localParams.parameter.countryCookisGet()
                }
            }
        }
        //  COMMON._executeApi(Enpoints.EP_GET_COUNTRIES_LIST,credentials,'',commit, (error, result)=>{
        // 	if(!error){
        // 		let country_array = [], count = 0 ;
        // 		for(var key in  result.res_data){
        // 			count++
        // 			country_array.push(result.res_data[key])
        // 			if(count == Object.keys(result.res_data).length){
        // 				commit(Const.SET_COUNTRIES_LIST, country_array)

        // 				if(credentials.localParams.page){
        // 					credentials.localParams.parameter.residence_country = country_array
        // 					credentials.localParams.parameter.countryCookisGet()
        // 				}
        // 			}
        // 		}
        // 	}else{
        // 		commit(Const.SET_COUNTRIES_LIST, [])
        // 	}
        // })
    },
    [Const.RUN_GET_CITIES_LIST]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_CITIES_LIST, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_CITIES_LIST, result.res_data);
            } else {
                commit(Const.SET_CITIES_LIST, []);
            }
        });
    },
    //=================================trading accounts====================================================
    [Const.RUN_CREATE_API_SUBSCRIPTION]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_CREATE_API_SUBSCRIPTION, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                dispatch(Const.RUN_GET_TRADING_ACCOUNT_LIST, { globalParams: {}, localParams: { parameter: credentials.localParams.parameter, page: "rest-api" } });
                credentials.localParams.parameter.congratulation_module = true;
                credentials.localParams.parameter.account_detail = result.res_data.account;
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_IB_PDF_NAME]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_IB_MAMM_UNSIGNED_AGREEMENT, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.ibMamPdfName = result.res_data.doc;
            } else {
                // COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_CREATE_IB_MAM_PAMM_ACCOUNT]({ commit, state, getters, dispatch }, credentials) {
        // credentials.localParams.parameter.$router.replace("/create-ib-mamm-pamm-account");
        COMMON._executeApi(Enpoints.EP_SAVE_IB_MAMM_DISCLAIMER, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, "mampamm_account_Disclaimer_Approved_Successfully", "success");
                setTimeout(() => {
                    credentials.localParams.parameter.$router.replace({name: "fxView.createIbMamPammAccount", params: {doc: credentials.localParams.parameter.ibMamPdfName, terms_conditions:credentials.globalParams.terms_agreed}});
                }, 1000);
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_msg, "error");
            }
        });
    },
    [Const.RUN_CREATE_ACCOUNT]({ commit, state, getters, dispatch }, credentials) {
        const api = credentials.globalParams.is_ib_mamm ? Enpoints.EP_CREATE_PAMM_ACCOUNT : Enpoints.EP_CREATE_ACCOUNT;
        COMMON._executeApi(api, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                dispatch(Const.RUN_GET_TRADING_ACCOUNT_LIST, { globalParams: {}, localParams: { parameter: credentials.localParams.parameter } });
                credentials.localParams.parameter.congratulation_module = true;
                credentials.localParams.parameter.account_detail = result.res_data.account;
                const demoLive = result.res_data.account.demo_live
                if(demoLive == 1){
                    // localStorage.removeItem("usFatca");
                    // localStorage.removeItem("is_crs");
                    sessionStorage.setItem('account_detail', JSON.stringify(result.res_data.account))
                    console.log('SetData')
                }
                commit(Const.SET_CHANGE_ACCOUNT_DATA_FORM_FORM_DISPLATY, "");
                if (credentials.globalParams.demo_live && parseInt(credentials.globalParams.demo_live) == 1) {
                    let user_json = getters["GET_USER"];
                    const user_id = user_json.profile.user_id;
                    if(credentials.localParams.parameter.$router.history.current.fullPath == "/step3"){
                        window.gtag("event", "Active_account", { event_name: "Active_account"});
                    }
                    window.gtag("event", "G_Ver_Live_Ac", { event_name: "G_Ver_Live_Ac" /*, 'send_to': 'G-1E20EEPN1W', 'user_id': user_id*/ });
                    window.fbq("trackCustom", "Verified_live_Account", { value: "50", country: user_json.profile.residence_country, Currency: "USD" }, { eventID: result.res_data.account.account_id });
                    window.teads_e.push({ conversionType: "CompleteRegistration" });
                }
            } else {
                credentials.localParams.parameter.errorScroll();
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_ACCOUNT_HISTORY]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi("/get/account/history", credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                let account_detail = getters[Const.GET_ACCOUNT_DETAILS];
                account_detail.history.csv_array = result.res_data;
                commit(Const.SET_ACCOUNT_DETAILS, account_detail);
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_ADD_LAST_SELECT_TRADING_ACCOUNT]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_RUN_ADD_LAST_SELECT_TRADING_ACCOUNT, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_LAST_SELECT_TRADING_ACCOUNT, credentials.localParams.getData);
                //localStorage.setItem('last_select_trading_account', JSON.stringify(credentials.localParams.getData))
                credentials.localParams.parameter.$parent.showTradingAccountModal = false;
                let json_data = {
                    globalParams: {
                        act_account_id: credentials.localParams.getData[0].act_account_id,
                        account_id: credentials.localParams.getData[0].account_id, //5111714,
                        demo_live: credentials.localParams.getData[0].demo_live,
                        platform: credentials.localParams.getData[0].platform,
                    },
                    localParams: { parameter: credentials.localParams.parameter },
                };
                /*if(credentials.localParams.getData[0].platform == 'ACT'){
                    json_data.globalParams.account_id = credentials.localParams.getData[0].act_account_id
                }*/
                dispatch(Const.RUN_GET_TRADING_ACCOUNT_DETAILS, json_data);
            } else {
                commit(Const.SET_LAST_SELECT_TRADING_ACCOUNT, []);
            }
        });
    },
    [Const.RUN_GET_TRADING_ACCOUNT_DETAILS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_TRADING_ACCOUNT_DETAILS, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                //single api from frontend which fetch  balance margin and trade of last selected trading account
                if (credentials.localParams.module == "withdrawal") {
                    credentials.localParams.parameter.balance = parseFloat(result.res_data.margin_detail.equity).toFixed(2);
                    credentials.localParams.parameter.free_margin = parseFloat(parseFloat(result.res_data.margin_detail.freeMargin) - parseFloat(result.res_data.margin_detail.credit)).toFixed(2);
                } else if (credentials.localParams.module == "remove-bonus") {
                    credentials.localParams.parameter.bonus = parseFloat(result.res_data.margin_detail.credit).toFixed(2);
                } else if (credentials.localParams.module == "from") {
                    if (typeof result.res_data.margin_detail == "object") {
                        let creditAllowedToTransfer = parseFloat(result.res_data.margin_detail.freeMargin) - parseFloat(result.res_data.margin_detail.credit);
                        creditAllowedToTransfer = parseFloat(creditAllowedToTransfer).toFixed(2);
                        credentials.localParams.parameter.fromBalance = creditAllowedToTransfer;
                        credentials.localParams.parameter.fromBalanceCurr = creditAllowedToTransfer + " " + credentials.localParams.parameter.from_currency;
                    } else {
                        credentials.localParams.parameter.fromBalance = 0;
                        credentials.localParams.parameter.fromBalanceCurr = 0;
                    }
                } else if (credentials.localParams.module == "to") {
                    if (typeof result.res_data.margin_detail == "object") {
                        let creditAllowedToTransfer = parseFloat(result.res_data.margin_detail.freeMargin) - parseFloat(result.res_data.margin_detail.credit);
                        creditAllowedToTransfer = parseFloat(creditAllowedToTransfer).toFixed(2);
                        credentials.localParams.parameter.toBalance = creditAllowedToTransfer;
                        credentials.localParams.parameter.toBalanceCurr = creditAllowedToTransfer + " " + credentials.localParams.parameter.to_currency;
                    } else {
                        credentials.localParams.parameter.toBalance = 0;
                        credentials.localParams.parameter.toBalanceCurr = 0;
                    }
                } else {
                    if (credentials.globalParams.platform != "ACT") {
                        //console.log('1111111111',result.res_data.open_trades.csv_array.length)

                        if (result.res_data.open_trades.csv_array && result.res_data.open_trades.csv_array.length > 0) {
                            //console.log('2222222222',result.res_data.open_trades.csv_array[0].length)
                            //console.log('3333333333',result.res_data.open_trades.csv_array[0])
                            if (result.res_data.open_trades.csv_array[0].length == 1 || result.res_data.open_trades.csv_array[0].length == 0) {
                                result.res_data.open_trades.csv_array.shift();
                            }
                        } else {
                            result.res_data.open_trades.csv_array = [];
                        }

                        if (result.res_data.history.csv_array && result.res_data.history.csv_array.length > 0) {
                            if (result.res_data.history.csv_array[0].length == 1 || result.res_data.history.csv_array[0].length == 0) {
                                result.res_data.history.csv_array.shift();
                            }
                        } else {
                            result.res_data.history.csv_array = [];
                        }
                    } else if (credentials.localParams.module == "from") {
                        credentials.localParams.parameter.fromBalance = "";
                        credentials.localParams.parameter.fromBalanceCurr = "";
                    } else if (credentials.localParams.module == "to") {
                        credentials.localParams.parameter.toBalance = "";
                        credentials.localParams.parameter.toBalanceCurr = "";
                    }
                    commit(Const.SET_ACCOUNT_DETAILS, result.res_data);
                }
            } else {
                commit(Const.SET_ACCOUNT_DETAILS, []);
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_ACCOUNT_PRIORITY_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_ACCOUNT_PRIORITY_LIST, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_ACCOUNT_DETAILS, []);
                credentials.localParams.parameter.id = "";
                credentials.localParams.parameter.tradingAccountListFunc();
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    //=================================trading-acc-list=========================================
    [Const.RUN_GET_TRADING_ACCOUNT_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_TRADING_ACCOUNT_LIST, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (credentials.localParams.page && credentials.localParams.page == "rest-api") {
                    if (result.res_data.totalRecords > 0) {
                        let count1 = 0;
                        for (let i = 0; i <= result.res_data.totalRecords - 1; i++) {
                            if (parseInt(result.res_data.records[i].demo_live) == 1 && parseInt(result.res_data.records[i].is_api_account) == 1) {
                                // if(parseInt(result.res_data.records[i].is_wallet || '0') == 1){}
                                count1++;
                            }
                            if (result.res_data.records.length - 1 == i) {
                                credentials.localParams.parameter.totalRestApiAccounts = count1;
                                credentials.localParams.parameter.restApiAccountsData = result.res_data;
                            }
                        }
                    } else {
                        credentials.localParams.parameter.totalRestApiAccounts = 0;
                        credentials.localParams.parameter.restApiAccountsData = [];
                    }
                } else {
                    if (result.res_data.totalRecords > 0) {
                        let live = 0,
                            liveArray = [],
                            demo = 0,
                            demoArray = [],
                            zulu = 0,
                            zuluArray = [],
                            ibMamPamm = 0,
                            ibMamPammArray = [];
                        for (let i = 0; i <= result.res_data.totalRecords - 1; i++) {
                            if (result.res_data.records[i].is_wallet && parseInt(result.res_data.records[i].is_wallet) == 1) {
                                // let arrayData = []
                                // arrayData.push(result.res_data.records[i])
                                // commit(Const.SET_WALLET_ACCOUNT, {'records' : arrayData , 'totalRecords' : 1 })
                            } else {
                                if (parseInt(result.res_data.records[i].demo_live) == 1) {
                                    live++;
                                    liveArray.push(result.res_data.records[i]);
                                }
                                if (parseInt(result.res_data.records[i].demo_live) == 0) {
                                    demo++;
                                    demoArray.push(result.res_data.records[i]);
                                }
                                if (result.res_data.records[i].platform != null && result.res_data.records[i].platform.toUpperCase() == "ZULU") {
                                    zulu++;
                                    zuluArray.push(result.res_data.records[i]);
                                }
                                if (result.res_data.records[i].platform != null && parseInt(result.res_data.records[i].is_ib_mamm) === 1) {
                                    ibMamPamm++;
                                    ibMamPammArray.push(result.res_data.records[i]);
                                }

                                if (parseInt(result.res_data.records[i].last_selected) == 1) {
                                    commit(Const.SET_LAST_SELECT_TRADING_ACCOUNT, [result.res_data.records[i]]);
                                }
                            }
                            if (result.res_data.records.length - 1 == i) {
                                let demoArray1 = demoArray.sort(COMMON.compare);
                                let liveArray1 = liveArray.sort(COMMON.compare);
                                let zuluArray1 = zuluArray.sort(COMMON.compare);
                                let ibMamPammArray1 = ibMamPammArray.sort(COMMON.compare);

                                result.res_data.totalLiveAccounts = live;
                                result.res_data.records = liveArray1.concat(demoArray1);

                                commit(Const.SET_TRADING_ACCOUNT_LIST, result.res_data);
                                commit(Const.SET_DEMO_ACCOUNT_LIST, { records: demoArray1, totalRecords: demo });
                                commit(Const.SET_LIVE_ACCOUNT_LIST, { records: liveArray1, totalRecords: live });
                                commit(Const.SET_ZULU_ACCOUNT_LIST, { records: zuluArray1, totalRecords: zulu });
                                commit(Const.SET_IB_MAM_PAMM_ACCOUNT_LIST, { records: ibMamPammArray1, totalRecords: ibMamPamm });
                                if (credentials.localParams.demo_live) {
                                    credentials.localParams.parameter.accountSelectFunc();
                                }
                            }
                            // console.log('------------->1',credentials.localParams,credentials.localParams.parameter.liveAccountList)
                            // if(credentials.localParams.page && credentials.localParams.page == "Step-3"){
                            //     if(live > 0){
                            //         // credentials.localParams.parameter.congratulation_module = true;
                            //         // const getAccountdetail = localStorage.getItem('account_detail');
                            //         // this.account_detail = JSON.parse(getAccountdetail || '{}');
                            //         // if(this.account_detail.demo_live == 1){
                            //         //     console.log("step 3")
                            //         //     // this.congratulation_module = true;
                            //         //     credentials.localParams.parameter.$router.push('/step3')
                            //         // }
                            //         credentials.localParams.parameter.$router.push('/step4')
                            //     }
                            //     console.log('------------->2',credentials.localParams.parameter.liveAccountList)
                            // }
                        }
                    } else {
                        result.res_data.totalLiveAccounts = 0;
                        commit(Const.SET_LIVE_ACCOUNT_LIST, { records: [], totalRecords: 0 });
                        commit(Const.SET_DEMO_ACCOUNT_LIST, { records: [], totalRecords: 0 });
                        commit(Const.SET_ZULU_ACCOUNT_LIST, { records: [], totalRecords: 0 });
                        commit(Const.SET_IB_MAM_PAMM_ACCOUNT_LIST, { records: [], totalRecords: 0 });
                        // commit(Const.SET_WALLET_ACCOUNT, {'records' : [] , 'totalRecords' : 0 })
                        commit(Const.SET_TRADING_ACCOUNT_LIST, result.res_data);
                        if (credentials.localParams.demo_live) {
                            credentials.localParams.parameter.accountSelectFunc();
                        }
                    }
                    //console.log('----------------',getters[Const.GET_LIVE_ACCOUNT_LIST])
                    dispatch(Const.RUN_GET_WALLET_DETAIL, { globalParams: {}, localParams: { parameter: credentials.localParams.parameter } });
                }
            } else {
                if (credentials.localParams.page && credentials.localParams.page == "rest-api") {
                    credentials.localParams.parameter.totalRestApiAccounts = 0;
                    credentials.localParams.parameter.restApiAccountsData = [];
                } else {
                    commit(Const.SET_LIVE_ACCOUNT_LIST, {});
                    commit(Const.SET_DEMO_ACCOUNT_LIST, {});
                    commit(Const.SET_ZULU_ACCOUNT_LIST, {});
                    commit(Const.SET_IB_MAM_PAMM_ACCOUNT_LIST, {});
                    // commit(Const.SET_WALLET_ACCOUNT, [])
                    commit(Const.SET_TRADING_ACCOUNT_LIST, {});
                }
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    //=================================manage-account======================================================
    [Const.RUN_AMOUNT_CONVERSION_API]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_AMOUNT_CONVERSION_API, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.conversionAmount = true;
                credentials.localParams.parameter.responseAmount = result.res_data;
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_ACCOUNT_PASSWORD_REQUEST_OTP]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_ACCOUNT_PASSWORD_REQUEST_OTP, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                let user_json = getters["GET_USER"];
                credentials.localParams.parameter.transaction_id = result.res_data.trans_id;
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_ACCOUNT_PASSWORD_CHECK_OTP]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_ACCOUNT_PASSWORD_CHECK_OTP, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (credentials.localParams.params) {
                    credentials.localParams.parameter.success = true;
                } else {
                    credentials.localParams.parameter.transaction_id = "";
                    credentials.localParams.parameter.congModulePass = true;
                }
            } else {
                if (credentials.localParams.params) {
                    credentials.localParams.parameter.success = false;
                    credentials.localParams.parameter.msg = result.res_data;
                    credentials.localParams.parameter.res_msg = result.res_msg;
                } else {
                    COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
                }
            }
        });
    },
    [Const.RUN_INTERNAL_TRANSFER_CHECK_OTP]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_INTERNAL_TRANSFER_CHECK_OTP, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (credentials.localParams.params) {
                    credentials.localParams.parameter.success = true;
                } else {
                    credentials.localParams.parameter.transaction_id = "";
                    credentials.localParams.parameter.congModuleIntTransfer = true;
                    let json = {
                        account_id: result.res_data.account_id,
                        to_account_id: result.res_data.to_account_id,
                        amount: result.res_data.amount,
                        trans_amount: result.res_data.to_amount,
                    };
                    credentials.localParams.parameter.res_data = json;
                }
                dispatch(Const.RUN_GET_WALLET_BALANCE, { globalParams: {}, localParams: { parameter: credentials.localParams.parameter } });
            } else {
                if (credentials.localParams.params) {
                    credentials.localParams.parameter.success = false;
                    credentials.localParams.parameter.msg = result.res_data;
                    credentials.localParams.parameter.res_msg = result.res_msg;
                } else {
                    COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
                }
            }
        });
    },
    [Const.RUN_ACCOUNT_LEVERAGE_CHECK_OTP]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_ACCOUNT_LEVERAGE_CHECK_OTP, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            console.log("action file 2222", error);
            if (!error) {
                if (credentials.localParams.params && credentials.localParams.params == "request-verify12") {
                    credentials.localParams.parameter.success = true;
                } else {
                    credentials.localParams.parameter.transaction_id = "";
                    credentials.localParams.parameter.congModuleLev = true;
                }

                dispatch(Const.RUN_GET_TRADING_ACCOUNT_LIST, { globalParams: {}, localParams: { parameter: credentials.localParams.parameter } });
            } else {
                if (credentials.localParams.params && credentials.localParams.params == "request-verify12") {
                    credentials.localParams.parameter.success = false;
                    credentials.localParams.parameter.msg = result.res_data;
                    credentials.localParams.parameter.res_msg = result.res_msg;
                } else {
                    COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
                }
            }
        });
    },
    [Const.RUN_RESEND_EMAIL_LINK_ACCOUNTS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_RESEND_EMAIL_LINK_ACCOUNTS, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, "suceessMsz16", "success");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    //=================================bonus===============================================================
    [Const.RUN_TRADING_BONUS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_TRADING_BONUS, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.bonus = result.res_data.allowedBonus;
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_BONUS_REQUEST_OTP]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_BONUS_REQUEST_OTP, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                let user_json = getters["GET_USER"];
                credentials.localParams.parameter.transaction_id = result.res_data.trans_id;
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_BONUS_CHECK_OTP]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_BONUS_CHECK_OTP, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                let _that = credentials.localParams.parameter;
                if (credentials.localParams.params) {
                    _that.success = true;
                } else {
                    _that.transaction_id = "";
                    _that.congModuleBonus = true;
                    _that.balance_bonus = parseFloat(_that.bonus) - parseFloat(_that.amount);
                }
            } else {
                if (credentials.localParams.params) {
                    credentials.localParams.parameter.success = false;
                    credentials.localParams.parameter.msg = result.res_data;
                } else {
                    COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
                }
            }
        });
    },
    [Const.RUN_LOYALITY_SUBSCRIP_VERIFY]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_LOYALITY_SUBSCRIP_VERIFY, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                let _that = credentials.localParams.parameter;
                _that.success = true;
            } else {
                credentials.localParams.parameter.success = false;
                credentials.localParams.parameter.msg = result.res_data;
            }
        });
    },
    [Const.RUN_GET_BONUS_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_BONUS_LIST, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_BONUS_LIST, result.res_data);
            } else {
                commit(Const.SET_BONUS_LIST, []);
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_REMOVE_BONUS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_REMOVE_BONUS, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (credentials.localParams.params) {
                    credentials.localParams.parameter.success = true;
                } else {
                    credentials.localParams.parameter.congModuleBonus = true;
                    credentials.localParams.parameter.transaction_id = "";
                }
            } else {
                if (credentials.localParams.params) {
                    credentials.localParams.parameter.success = false;
                    credentials.localParams.parameter.msg = result.res_data;
                } else {
                    COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
                }
            }
        });
    },
    [Const.RUN_RESEND_EMAIL_LINK_BONUS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_RESEND_EMAIL_LINK_BONUS, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, "suceessMsz16", "success");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    //=================================withdrawal==========================================================
    [Const.RUN_GET_WITHDRAWAL_DESC]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_WITHDRAWAL_DESC, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                let currencyIcon = { EUR: "€", USD: "$", GBP: "£", CHF: "CHF", JPY: "¥", AUD: "$" };
                let withdrawalAlloCredit = parseFloat(result.res_data.margin_detail.freeMargin) - parseFloat(result.res_data.margin_detail.credit);
                credentials.localParams.parameter.free_margin = withdrawalAlloCredit;
                credentials.localParams.parameter.free_margin_currency = withdrawalAlloCredit + " " + (currencyIcon[credentials.localParams.parameter.currencyData] || credentials.localParams.parameter.currencyData);
                if (credentials.localParams.page && credentials.localParams.page == "subscription") {
                    return;
                }
                if (credentials.localParams.page && credentials.localParams.page == "subscription") {
                    return;
                }
                if (Object.keys(result.res_data.allowedWithdrawal).length > 0) {
                    credentials.localParams.parameter.allowedWithdrawal = result.res_data.allowedWithdrawal;
                } else {
                    let json = {},
                        count = 0;
                    let get_withdrawal_method = getters[Const.GET_WITHDRAWAL_METHOD_RESPONSE_DEP];
                    for (var key in get_withdrawal_method) {
                        count++;

                        json[key] = {};
                        let count1 = 0;
                        if (parseInt(key) != 18) {
                            for (var innerkey in get_withdrawal_method[key]) {
                                count1++;
                                json[key][innerkey] = {};
                                json[key][innerkey][credentials.localParams.parameter.currencyData] = result.res_data.margin_detail.freeMargin;
    
                                if (parseInt(key) != 5) {
                                    json[key][innerkey]["allowed"] = "1";
                                }
                            }
    
                            if (count == Object.keys(get_withdrawal_method).length) {
                                credentials.localParams.parameter.allowedWithdrawal = json;
                                credentials.localParams.parameter.showBalPanel = false;
                            }
                        } else {
                            json[key]["0"] = {};
                            json[key]["0"][credentials.localParams.parameter.currencyData] = result.res_data.margin_detail.freeMargin;
                            json[key]["0"]["allowed"] = "1";
                            credentials.localParams.parameter.allowedWithdrawal = json;
                            credentials.localParams.parameter.showBalPanel = false;
                        }
                    }
                }

                credentials.localParams.parameter.pay_option = "";
                credentials.localParams.parameter.amount = "";
                credentials.localParams.parameter.avalBalance = "";
                credentials.localParams.parameter.account_number = "";
                credentials.localParams.parameter.submitted = false;
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_WITHDRAWAL_REQUEST_OTP]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_WITHDRAWAL_REQUEST_OTP, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.transaction_id = result.res_data.trans_id;
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_WITHDRAWAL_CHECK_OTP]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_WITHDRAWAL_CHECK_OTP, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (credentials.localParams.params) {
                    credentials.localParams.parameter.success = true;
                } else {
                    credentials.localParams.parameter.transaction_id = "";
                    credentials.localParams.parameter.congModuleWithdrawal = true;
                }
                dispatch(Const.RUN_GET_WALLET_BALANCE, { globalParams: {}, localParams: { parameter: credentials.localParams.parameter } });
            } else {
                if (credentials.localParams.params) {
                    credentials.localParams.parameter.success = false;
                    credentials.localParams.parameter.msg = result.res_data;
                } else {
                    COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
                }
            }
        });
    },
    [Const.RUN_RESEND_EMAIL_LINK]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_RESEND_EMAIL_LINK, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, "suceessMsz16", "success");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_WITHDRAWAL_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_WITHDRAWAL_LIST, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_WITHDRAWAL_LIST, result.res_data);
            } else {
                commit(Const.SET_WITHDRAWAL_LIST, []);
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },

    [Const.RUN_GET_WITHDRAWAL_METHODS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_WITHDRAWAL_METHODS, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (Array.isArray(result.res_data)) {
                    commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE, {});
                    commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE_DEP, {});
                } else {
                    commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE, result.res_data);
                    let json = {},
                        count = 0;
                    for (var key in result.res_data) {
                        count++;
                        json[key] = {};
                        let count1 = 0;
                        for (var innerkey in result.res_data[key]) {
                            count1++;
                            json[key][result.res_data[key][innerkey].id] = result.res_data[key][innerkey];
                            if (count1 == Object.keys(result.res_data[key]).length) {
                                ////console.log(json)
                            }
                        }
                        if (count == Object.keys(result.res_data).length) {
                            commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE_DEP, json);
                        }
                    }
                }
            } else {
                commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE_DEP, {});
                commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE, {});
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },

    //=================================deposit=============================================================
    [Const.RUN_TRANS_LIMIT_CURRENCY]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_TRANS_LIMIT_CURRENCY, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.shwStep = 2;
                credentials.localParams.parameter.responseTransLimitData = result.res_data;
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_TRANSACTION_STATUS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_TRANSACTION_STATUS, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (result.res_data.length > 0) {
                    credentials.localParams.parameter.trans_hitory = result.res_data;
                }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_DEPOSIT_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_DEPOSIT_LIST, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_DEPOSIT_LIST, result.res_data);
                credentials.localParams.parameter.depositSumUSD = result.res_data.deposit_sum_usd;
                // if(!localStorage.getItem('initialLoad')){
                //     credentials.localParams.parameter.openModal()
                //     localStorage.setItem('initialLoad', true)
                // }
                // credentials.localParams.parameter.depositSumUSD = result.res_data.deposit_sum_usd || 2000;
                // if(credentials.localParams.from && credentials.localParams.from == 'dashboard'){
                try {
                    credentials.localParams.parameter.callDepositFunc();
                } catch (e) { }
                // }
            } else {
                commit(Const.SET_DEPOSIT_LIST, []);
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },

    [Const.RUN_GET_DEPOSIT_LIST_FTD]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_DEPOSIT_LIST, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (result.res_data.records) {
                    // console.log("1", result.res_data.records);
                    const firstRecord = result.res_data.records[0];
                    const userId = getters[types.GET_USER].profile.user_id;
                    // console.log('firstRecord', firstRecord, '111111111111111', userId);
                    if (firstRecord && userId > 60270 && firstRecord.amount >= 5000 && firstRecord.currency === 'USD') {
                        // console.log("2")
                        credentials.localParams.parameter.ftdRecord = firstRecord;
                        credentials.localParams.parameter.ftdAmount = firstRecord.amount;
                        credentials.localParams.parameter.premiumECN = false;
                    } else if (firstRecord && userId > 60270 && firstRecord.currency !== 'USD') {
                        // console.log("3")
                        credentials.localParams.parameter.conversionOfAmount(firstRecord.currency, firstRecord.amount);
                    } else if (!firstRecord && userId > 60270) {
                        // console.log("4")
                        credentials.localParams.parameter.premiumECN = true;
                    } else {
                        // console.log("credentials.localParams.parameter.premiumECN", result.res_data.records.length > 0)
                        if (result.res_data.records.length > 0) {
                            credentials.localParams.parameter.premiumECN = false;
                        } else {
                            credentials.localParams.parameter.premiumECN = true;
                        }
                    }
                }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_CREDIT_CARD_DEPOSIT]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_CREDIT_CARD_DEPOSIT, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (result.res_data.url) {
                    goToUrl(result.res_data.url, "_self");
                } else {
                    credentials.localParams.parameter.transaction_id = result.res_data.transaction_id;
                    credentials.localParams.parameter.submitPay(result.res_data.transaction_id);
                }
                try {
                    /*window.dataLayer.push({
                            'event' : 'addfund',
                        'fundMethod' : 'card',
                    })*/
                } catch (ex) {
                    console.log("ex", ex);
                }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    //KORAPAY Deposit
    [Const.RUN_KORAPAY_DEPOSIT]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_KORAPAY_DEPOSIT, credentials, { Authorization: "Bearer " + getters.GET_TOKEN  }, commit, (error, result) => {
            if (!error) {
                goToUrl(result.res_data.payment_url, "_self");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_KORAPAY_CURRENCY_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_KORAPAY_CURRENCY_LIST, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.korapayCurrency = Object.keys(result.res_data)[0];
                credentials.localParams.parameter.korapayCurrencyList = result.res_data;
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_CRYPTO_DEPOSIT]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_CRYPTO_DEPOSIT, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.shwStep = 16;
                credentials.localParams.parameter.cryptoDepositAddress = result.res_data.address;
                // goToUrl(result.res_data.link,'_self');
                // credentials.localParams.parameter.cyrptAddress = result.res_data.address
                // credentials.localParams.parameter.shwStep = -4

                // credentials.localParams.parameter.transaction_id = result.res_data.transaction_id
                // credentials.localParams.parameter.submitPay(result.res_data.transaction_id);
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_DEMO_DEPOSIT]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_DEMO_DEPOSIT, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.reset();
                if (credentials.localParams.page == "man_account") {
                    credentials.localParams.parameter.fund_msz = "fund_msz";
                    credentials.localParams.parameter.fund_msz_type = "success";
                } else {
                    COMMON._messageDisplayFunction(credentials.localParams.parameter, "suceessMsz17", "success");
                }
            } else {
                if (credentials.localParams.page == "man_account") {
                    credentials.localParams.parameter.fund_msz = result.res_data;
                    credentials.localParams.parameter.fund_msz_type = "error";
                } else {
                    COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
                }
            }
        });
    },
    [Const.RUN_GET_USER_CAN_DEPOSIT]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_USER_CAN_DEPOSIT, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                //console.log('------', result.res_data)
                commit(Const.SET_DEPOSIT_LIMIT, result.res_data);
            } else {
                commit(Const.SET_DEPOSIT_LIMIT, []);
                // COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
            }
        });
    },
    // Swiffy Bank Detail
    // [Const.RUN_SWIFFY_DETAILS]({ commit, state, getters, dispatch }, credentials) {
    // 	COMMON._executeApi(Enpoints.EP_SWIFFY_DETAILS, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
    // 		if (!error) {
    // 			COMMON._messageDisplayFunction(credentials.localParams.parameter.$parent, 'suceessMsz20', 'success')
    // 		} else {
    // 			COMMON._messageDisplayFunction(credentials.localParams.parameter.$parent, result.res_data, 'error')
    // 		}
    // 	})
    // },
    [Const.RUN_SWIFFY_DETAILS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_SWIFFY_DETAILS, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                goToUrl(result.res_data.url, "_blank");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    // Help2Pay payment info
    [Const.RUN_HELP2PAY_PAYMENTINFO]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_HELP2PAY_PAYMENTINFO, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.help2paymentInfo(result.res_data);
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },

    // Help2Pay Detail
    [Const.RUN_HELP2PAY_DETAILS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_HELP2PAY_DETAILS, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.help2payFormData = result.res_data;
                let abc = new DOMParser().parseFromString(result.res_data, "text/html");
                var div = document.createElement("div");
                div.innerHTML = abc.body.innerHTML.trim();
                let form_data = div.firstChild;
                form_data.style.display = "none";
                form_data.setAttribute("target", "_blank");
                console.log("form_data=================>", form_data);
                // form_data.action = Enpoints.HELP2PAY_LINK;
                document.body.appendChild(form_data);
                form_data.submit();
                // console.log(result.res_data, "===========my result")
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    // Astropay Detail
    [Const.RUN_ASTROPAY_DETAILS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_ASTROPAY_DETAILS, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (result.res_data.url) {
                    goToUrl(result.res_data.url, "_blank");
                } else if (result.res_data.payment_detail) {
                    credentials.localParams.parameter.reset();
                    credentials.localParams.parameter.qr_image = result.res_data.payment_detail.qr_image;
                    credentials.localParams.parameter.qr = result.res_data.payment_detail.qr;
                } else if (result.res_data.error) {
                    credentials.localParams.parameter.doc_error = result.res_data.error;
                }
            } else {
                console.log("4");
                credentials.localParams.parameter.doc_error = result.data.info;
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    //Astropay curreny conversion
    [Const.RUN_ASTROPAY_CURRENCY_CONVERSION]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_ASTROPAY_CURRENCY_CONVERSION, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.astropayConvertedAmount = result.res_data;
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    // Astropay Affiliate Login
    [Const.RUN_ASTROPAY_AFFILIATE_LOGIN]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_ASTROPAY_AFFILIATE_LOGIN, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                let data = { token: result.res_data.login_token, loggedIn: true, roles: "", email: "", profile: {} };
                localStorage.setItem("user", btoa(JSON.stringify(data)));
                let src = document.location.origin + "/dashboard";
                location.replace(src);
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    // Nuvei Detail
    [Const.RUN_NUVEI_DETAILS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_NUVEI_DETAILS, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                goToUrl(result.res_data.paymentUrl, "_blank");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    // Nuvei Detail
    [Const.RUN_GET_TRUST_PAY_DETAILS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_TRUST_PAY_DETAILS, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                console.log("============>", result.res_data);
                // const { FORM_ACTION_URL } = data;
                const form = document.createElement("form");
                form.style.display = "none";
                form.method = "POST"; // Set the HTTP method
                form.action = process.env.trust_pay_url; // Set the third-party URL
                form.target = "_blank"; // Open the URL in a new tab or window
                // Submit the form using JavaScript
                const pushElement = (name, value) => {
                    let element = document.createElement("input");
                    element.setAttribute("type", "hidden");
                    element.setAttribute("name", name);
                    element.setAttribute("value", value);
                    form.append(element);
                };
                for (let key in result.res_data) {
                    if (!["amount", "currency", "account_id", "method_id"].includes(key)) {
                        if (Array.isArray(result.res_data[key])) {
                            result.res_data[key].forEach((v) => {
                                pushElement(key, v);
                            });
                        } else pushElement(key, result.res_data[key]);
                    }
                }
                console.log("------------->", form);
                document.body.appendChild(form);
                form.submit();
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    // Perfect Money Detail
    [Const.RUN_PERFECT_MONEY_DETAILS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_PERFECT_MONEY_DETAILS, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                const { FORM_ACTION_URL } = result.res_data;
                const form = document.createElement("form");
                form.method = "POST"; // Set the HTTP method
                form.action = FORM_ACTION_URL; // Set the third-party URL
                form.target = "_blank"; // Open the URL in a new tab or window
                form.type = "hidden";
                form.style.display = "none";
                form.id = "frmPrfMoney";

                let row = result.res_data;
                for (const key in row) {
                    // console.warn(`${key}: ${row[key]}`);
                    if (key != "FORM_ACTION_URL") {
                        let input1 = document.createElement("input");
                        input1.type = "text";
                        input1.name = key;
                        input1.value = row[key]; // You can set the initial value here
                        form.appendChild(input1);
                    }
                }
                // Append the form to the document body
                document.body.appendChild(form);
                // Submit the form using JavaScript
                form.submit();
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    // Payguru Detail
    [Const.RUN_PAYGURU_DETAILS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_PAYGURU_DETAIL, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                goToUrl(result.res_data.url, "_blank");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_ALL_CURRENCY_LIST]({ commit, state, dispatch, getters }, credentials) {
        if (getters.GET_CONVERSION_CURRENCY && Object.keys(getters.GET_CONVERSION_CURRENCY).length > 0) {
            // console.log(getters.GET_CONVERSION_CURRENCY)
        } else {
            COMMON._executeApi(Enpoints.EP_ALL_CURRENCY_LIST, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
                if (!error) {
                    localStorage.setItem("currencyList", window.btoa(JSON.stringify(result.res_data)));
                    commit(types.SET_CONVERSION_CURRENCY, result.res_data);
                } else {
                    COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
                }
            });
        }
    },

    //=================================support==============================================================
    [Const.RUN_TICKET_RESEND_OTP]({ commit, state, getters, dispatch }, credentials) {
        credentials.localParams.parameter.submitted = false;
        COMMON._executeApi(Enpoints.EP_TICKET_RESEND_OTP, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                COMMON._messageDisplayFunction(credentials.localParams.parameter.$parent, "suceessMsz18", "success");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter.$parent, result.res_data, "error");
            }
        });
    },
    [Const.RUN_TICKET_REQUEST_OTP]({ commit, state, getters, dispatch }, credentials) {
        credentials.localParams.parameter.submitted = false;
        COMMON._executeApi(Enpoints.EP_TICKET_REQUEST_OTP, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.trans_id = result.res_data.trans_id;
                if (credentials.localParams.type && credentials.localParams.type == "pro") {
                    credentials.localParams.parameter.show_step = "";
                }
            } else {
                if (credentials.localParams.type && credentials.localParams.type == "pro") {
                    credentials.localParams.parameter.show_step = "";
                }
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_TICKET_CHECK_OTP]({ commit, state, getters, dispatch }, credentials) {
        let localParam = credentials.localParams;
        // try{
        // 	localParam.parameter.submitted = false
        // 	localParam.parameter.$parent.submitted = false
        // }catch(e){}
        //,credentials.localParams.parameter.$parent
        COMMON._executeApi(Enpoints.EP_TICKET_CHECK_OTP, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (localParam.page && localParam.page == "subscribe") {
                    localParam.parameter.congModule = true;
                } else {
                    if (parseInt(localParam.module) == 1 && parseInt(localParam.title) == 87) {
                        credentials.localParams.parameter.$parent.$parent.$parent.$parent.logout();
                        // COMMON._messageDisplayFunction(credentials.localParams,'as you have changed your primary email , so please login again','success')
                    } else if (parseInt(localParam.module) == 1 && parseInt(localParam.title) == 88) {
                        let get_user = getters[types.GET_USER];
                        get_user.mobile_no = localParam.data;
                        commit(types.SET_STATE, get_user);

                        var user = localStorage.getItem("user");
                        user = atob(user);
                        user = JSON.parse(user);
                        user.mobile_no = credentials.localParams.data;
                        localStorage.setItem("user", btoa(JSON.stringify(user)));
                        localParam.parameter.$parent.congModule = true;
                    } else if (credentials.localParams.data && credentials.localParams.data == "pro") {
                        credentials.localParams.parameter.$parent.show_step = "";
                        localParam.parameter.$parent.congModule = true;
                    } else if (credentials.localParams.ticketRequestFrom == "increase-Limit") {
                        credentials.localParams.parameter.$router.push({ path: "/view", query: { id: result.res_data.insertId } });
                    } else if (parseInt(localParam.module) == 16) {
                        if (localParam.ticketRequestFrom == "deposit") {
                            localParam.parameter.$router.replace({ name: "accountfunding", params: { account_id_from_ticket: localParam.accountId } });
                        } else if (localParam.ticketRequestFrom == "profile") {
                            localParam.parameter.$router.replace("/profile");
                            COMMON._messageDisplayFunction(credentials.localParams.parameter.$parent, "bank add successfully", "success");
                            /*try {
                                window.dataLayer.push({
                                        'event' : 'addpaymentinfo',
                                    'paymentMethod' : 'bank',
                                })
                            } catch (ex) {
                                console.log('ex', ex)
                            }*/
                        } else if (localParam.ticketRequestFrom == "profileOtp") {
                            credentials.localParams.parameter.$parent.trans_id = "";
                            credentials.localParams.parameter.$parent.getUserProfileFunc();
                            COMMON._messageDisplayFunction(credentials.localParams.parameter.$parent, "payment method disable successfully", "success");
                        } else if (localParam.ticketRequestFrom == "bankDeposit") {
                            credentials.localParams.parameter.$parent.trans_id = "";
                            localParam.parameter.$parent.congModule = true;
                        } else {
                            localParam.parameter.$parent.congModule = true;
                        }
                    } else {
                        localParam.parameter.$parent.congModule = true;
                    }
                }
            } else {
                if (credentials.localParams.data && credentials.localParams.data == "pro") {
                    credentials.localParams.parameter.$parent.show_step = "";
                }
                if (localParam.page && localParam.page == "subscribe") {
                    COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
                } else {
                    COMMON._messageDisplayFunction(credentials.localParams.parameter.$parent, result.res_data, "error");
                }
            }
        });
    },
    [Const.RUN_GET_TICKET_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_TICKET_LIST, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (credentials.localParams.parameter.$parent.setView != "" && parseInt(credentials.globalParams.status) == 0) {
                    let ticket_id = "";
                    for (let i = 0; i <= result.res_data.records.length - 1; i++) {
                        if (parseInt(result.res_data.records[i].reason) == 91) {
                            ticket_id = result.res_data.records[i].id;
                        }
                        if (i == result.res_data.records.length - 1) {
                            credentials.localParams.parameter.$router.replace({ name: "fxView.view", query: { id: ticket_id } });
                        }
                    }
                }
                commit(Const.SET_TICKET_LIST, result.res_data);
            } else {
                commit(Const.SET_TICKET_LIST, []);
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_TICKET_REASON_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_TICKET_REASON_LIST, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                let ticketData = COMMON._ticketFunction(result.res_data);
                commit(Const.SET_TICKET_DATA, ticketData);
                let count = 0;
                for (var key in result.res_data) {
                    count++;
                    if (result.res_data[key].categories && result.res_data[key].categories != undefined && result.res_data[key].categories.length > 0) {
                        let categoriesList = {};
                        for (let i = 0; i <= result.res_data[key].categories.length - 1; i++) {
                            categoriesList[result.res_data[key].categories[i].id] = result.res_data[key].categories[i];
                            if (i == result.res_data[key].categories.length - 1) {
                                delete result.res_data[key].categories;
                                result.res_data[key]["categories"] = categoriesList;
                            }
                        }
                    }
                    if (count == Object.keys(result.res_data).length) {
                        commit(Const.SET_TICKET_REASON_LIST, result.res_data);
                    }
                }
            } else {
                commit(Const.SET_TICKET_REASON_LIST, []);
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_TICKET_DETAIL]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_TICKET_DETAIL, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            console.log('onn RUN_GET_TICKET_DETAIL');
            if (!error) {
                commit(Const.SET_TICKET_VIEW, result.res_data);

                if (result.res_data.ipv != undefined && Object.keys(result.res_data.ipv).length > 0) {
                    credentials.localParams.parameter.subSubResp(result.res_data.ipv);
                }
            } else {
                commit(Const.SET_TICKET_VIEW, []);
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_TICKET_REPLY]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_TICKET_REPLY, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.ticketDetail();
                credentials.localParams.parameter.clear();
                let user_notify = getters[Const.GET_USER_NOTIFICATIONS];
                let i;
                if (user_notify.length > 0) {
                    for (i = 0; i <= user_notify.length - 1; i++) {
                        if (user_notify[i].notification_type == "TICKET" && user_notify[i].ticket_id == credentials.localParams.tick_id) {
                            let user_info = getters[types.GET_USER];
                            user_info.unread_notification = user_info.unread_notification - 1;
                            commit(types.SET_STATE, user_info);

                            var user = localStorage.getItem("user");
                            user = atob(user);
                            user = JSON.parse(user);
                            user.unread_notification = user.unread_notification - 1;
                            localStorage.setItem("user", btoa(JSON.stringify(user)));
                        }
                    }
                }
                // COMMON._messageDisplayFunction(credentials.localParams.parameter,'message sent successfully','success')
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_REQUEST_CALLBACK]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_REQUEST_CALLBACK, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.div_show = "1";
                credentials.localParams.parameter.reset();
                COMMON._messageDisplayFunction(credentials.localParams.parameter, "callback request sent successfully", "success");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    //=================================bank=================================================================
    [Const.RUN_ADD_BANK]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_ADD_BANK, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, "suceessMsz19", "success");
                /*try {
                    window.dataLayer.push({
                            'event' : 'addpaymentinfo',
                        'paymentMethod' : 'bank',
                    })
                } catch (ex) {
                    console.log('ex', ex)
                }*/
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [Const.RUN_GET_BANK_LIST]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_BANK_LIST, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_BANK_LIST, result.res_data);
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    //=================================dashboard chart======================================================
    [Const.RUN_GET_PROFIT_CHART_DATA]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_PROFIT_CHART_DATA, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                const _that = credentials.localParams.parameter;
                _that.profitData = result.res_data;
                _that.create_chart();
            }
        });
    },
    [Const.RUN_GET_BALANCE_DATA]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_BALANCE_DATA, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                const _that = credentials.localParams.parameter;
                _that.profitData = result.res_data;
            }
        });
    },
    [Const.RUN_GET_EQUITY_DATA]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_EQUITY_DATA, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                const _that = credentials.localParams.parameter;
                _that.profitData = result.res_data;
            }
        });
    },
    [Const.RUN_GET_TRADING_DATA]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_TRADING_DATA, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                const _that = credentials.localParams.parameter;
                _that.tradingData = result.res_data;
                _that.create_pie_chart();
            }
        });
    },
    [Const.RUN_GET_IDENFY_TOKEN]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_IDENFY_TOKEN, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                const _that = credentials.localParams.parameter;

                if (_that.$route.path == "/step3") {
                    _that.intializeSumSub(result.res_data.accesstoken, result.res_data.user_id, result.res_data.levelname);
                } else {
                    let payLoad = { accessToken: result.res_data.accesstoken, user_id: result.res_data.user_id, levelname: result.res_data.levelname };

                    EventBus.$emit("INTIALIZESUMSUB", payLoad);
                }

                // _that.iframe.src = "https://ui.idenfy.com/?authToken="+result.res_data.authToken
            }
        });
    },
    [Const.RUN_UPDATE_FIRST_DEPOSIT]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_UPDATE_FIRST_DEPOSIT, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                let get_user = getters[types.GET_USER];
                if (Object.keys(get_user).length > 0) {
                    get_user.first_deposit = 1;
                    commit(types.SET_STATE, get_user);
                }
                // COMMON._messageDisplayFunction(credentials.localParams.parameter, 'suceessMsz19', 'success')
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
};



// WEBPACK FOOTER //
// ./src/plugins/fxView/provider/candle-history/store-addons/actions.js